module.exports = __webpack_public_path__ + "static/media/jiabanyc.f1f2ec48.png";